<div class="d-flex text-primary p-2 align-items-center">
  <span class="font-sans-bold" [ngClass]="{'hidden' : isJuniorBluebirds}">{{ pointsBalance$ | async | FortressCurrencyPipe: 'PTS' }}</span>
</div>
